module.exports = __webpack_public_path__ + "static/media/vps-open-claw-br.4b99c4ed.png";